import { useCallback, useEffect, useState } from 'react';
import { describeError } from '../../services/errorMessage';
import { fetchTaetigkeiten } from '../../services/sifa/sifaBetreuungService';
import { SifaTaetigkeit } from '../../services/sifa/betreuungTypes';
import { sortiereTaetigkeiten } from './taetigkeitenModulLogic';

/**
 * Taetigkeiten eines SiFa-Projekts fuer EIN Kalenderjahr (sifa_taetigkeiten,
 * Nr. 92). Der Jahreswechsel laedt neu; eine gespeicherte Zeile mit anderem
 * Jahr faellt beim Uebernehmen aus der Liste — sie gehoert in eine andere
 * Jahresansicht.
 */
export const useTaetigkeiten = (projectId: string | null | undefined, jahr: number) => {
  const [taetigkeiten, setTaetigkeiten] = useState<SifaTaetigkeit[]>([]);
  const [laden, setLaden] = useState(true);
  const [fehler, setFehler] = useState<string | null>(null);

  const neuLaden = useCallback(async () => {
    if (!projectId) { setTaetigkeiten([]); setLaden(false); return; }
    setLaden(true);
    setFehler(null);
    try {
      setTaetigkeiten(sortiereTaetigkeiten(await fetchTaetigkeiten(projectId, jahr)));
    } catch (e) {
      setFehler(describeError(e));
    } finally {
      setLaden(false);
    }
  }, [projectId, jahr]);

  useEffect(() => { void neuLaden(); }, [neuLaden]);

  const uebernehmen = useCallback((geaendert: SifaTaetigkeit) => {
    setTaetigkeiten((prev) => {
      const ohne = prev.filter((t) => t.id !== geaendert.id);
      const imJahr = Number(geaendert.datum.slice(0, 4)) === jahr;
      return sortiereTaetigkeiten(imJahr ? [...ohne, geaendert] : ohne);
    });
  }, [jahr]);

  const entfernen = useCallback((id: string) => {
    setTaetigkeiten((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { taetigkeiten, laden, fehler, neuLaden, uebernehmen, entfernen };
};
